import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx';
import buttonGroupStyle from '../buttonGroupStyle';

const userProfileStyles = theme => ({
  ...buttonGroupStyle,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    '& small': {
      fontSize: '80%',
      fontWeight: '400',
    },
  },
  cardCategory: {
    margin: 0,
    color: '#999999 !important',
  },
  description: {
    color: '#999999',
  },
  updateProfileButton: {
    float: 'right',
  },
  logsBtn: {
    '&>span>span': {
      display: 'none',
    },
  },
  container: {
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse',
    },
  },
  actions: {
    padding: '8px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 370,
    },
  },
  userActions: {
    marginTop: 40,
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    '& div:last-child': {
      marginLeft: 16,
    },
  },
  userAds: {
    marginTop: 24,
  },
  userDetails: {
    marginTop: 24,
    '& h6': {
      fontSize: 13
    },
    '& h5': {
      margin: 0,
      fontSize: 16
    }
  },
  userActionsDetails: {
    marginTop: 24,
  },
  permissionsContainer: {
    background: 'white',
    borderRadius: 8,
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  blockedUser: {
    width: '100%',
    height: '100%',
    backgroundColor: '#ffffffd4',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    borderRadius: 8,
  },
  verticalAlignment: {
    display: 'flex',
    alignItems: 'center',
  },
  dateAlignment: {
    display: 'flex',
    alignItems: 'center',
  },
  dateIconSize: {
    width: 17,
  },
  adContent: {
    maxWidth: '100%',
    padding: '16px 0',
  },
  adCategories: {
    fontSize: '1.1em',
    fontWeight: 400,
    '@media (max-width: 959px)': {
      marginTop: 24,
    },
  },
  adStatus: {
    justifyContent: 'space-between',
    fontWeight: 500,
    textTransform: 'uppercase',
    fontSize: '0.9em',
    '@media (min-width: 960px)': {
      justifyContent: 'flex-end',
    },
  },
  infoAdPublish: {
    backgroundColor: '#00b564',
    borderRadius: '50px',
    padding: '2px 10px',
    color: 'white',
    margin: 0,
    '& svg': {
      width: 20,
      marginRight: 5,
    },
  },
  infoAdUnPublish: {
    backgroundColor: '#a6a6a6',
  },
  infoAdPending: {
    backgroundColor: '#ffb500',
  },
  infoAdExpired: {
    backgroundColor: '#808080',
  },
  infoAdValues: {
    fontWeight: 500,
    '& svg': {
      width: 20,
      height: 15,
    }
  },
  adDescription: {
    padding: '8px 16px',
    margin: '16px 0',
    background: '#f7f7f7',
    overflowWrap: 'break-word',
  },
  infoContact: {
    '& span': {
      marginLeft: 8,
    },
  },
  adDate: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
    },
    fontSize: '1.25em',
    lineHeight: '1.4em',
    marginTop: '5px',
    marginBottom: '5px',
  },
  actionsBtnLabel: {
    width: 40,
    '&>span>span': {
      display: 'none',
      '@media (min-width: 560px) and (max-width: 959px)': {
        display: 'block',
        width: 'auto',
      },
    },
    '@media (min-width: 560px) and (max-width: 959px)': {
      width: 'auto',
    },
  },
  arrow: {
    position: 'absolute',
    fontSize: 6,
    bottom: 0,
    left: 0,
    marginBottom: '-0.95em',
    width: '100%',
    height: '1em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '1em 1em 0 1em',
      borderColor: `#413636 transparent transparent transparent`,
    },
  },
  bootstrapPlacementTop: {
    margin: '8px 0',
  },
  bootstrapTooltip: {
    backgroundColor: '#413636',
    transform: 'translateY(10px)'
  },
  actionsLoader: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 1,
    backgroundColor: 'rgba(255, 255, 255, .9)',
    borderRadius: 6,
  },
  avatarContainer: {
    position: 'relative'
  },
  agencyLogo: {
    width: '28px',
    height: '28px',
    position: 'absolute',
    bottom: '-10px',
    right: '0'
  },
  changeCreditModalBtnsSection: {
    margin: '24px 8px 13px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  adAuto: {
    backgroundColor: '#ffb500',
    padding: '4px',
    color: 'white',
    fontWeight: 'bold',
    marginRight: '8px',
    fontSize: '8pt',
    borderRadius: '4px',
    lineHeight: '1.6',
  },
  adPromotionInfo: {
    padding: '0',
    marginRight: '20px',
    color: '#217DB2',
  },
  adsRelatedPromotion: {
    width: 15,
    height: 15,
  },
  adLinks: {
    textDecoration: 'underline',
    color: '#217DB2',
  },
  anchorButton: {
    borderRadius: '4px',
    padding: '5px 10px',
    backgroundColor: '#2DAAF2',
    marginTop: '10px',
    marginBottom: '10px',
    color: 'white',
    '&:hover': {
      color: 'white',
      textDecoration: 'underline',
    },
    '&:visited': {
      color: 'white',
    },
  },
  infoAdId: {
    padding: '0px 15px 0px 0px',
  },
  adTitle: {
    fontSize: '1.40em',
    lineHeight: '1.4em',
    fontWeight: 500,
  },
  secondaryAdInfo: {
    fontSize: '1.25em',
    lineHeight: '1.4em',
    marginTop: '5px',
    marginBottom: '5px',
  },
  botScoreError: {
    marginLeft: '8px',
    color: 'red'
  },
  secondaryInfoContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
  },
  secondaryInfoBlocks: {
    display: 'flex',
    flexFlow: 'row wrap',
  },
  listOfNotes: {
    listStyle: 'none',
    paddingLeft: 0,
  },
  noteItem: {
    justifyContent: 'space-between',
    borderBottom: '1px solid #cacaca',
    padding: '10px 0 10px 10px',
  },
  emptyNotes: {
    textAlign: 'center',
    fontStyle: 'italic',
    fontWeight: 400,
    color: 'lightgray',
    margin: '2em 0',
  },
  descriptionNotes: {
    fontSize: '0.8rem',
    fontWeight: 400,
    color: 'gray',
    marginTop: '0.3em',
  },
  imagesIconsContainer:{
    display: 'flex',
    flexFlow: 'row wrap',
  },
  imageIconContainer:{
    position: 'relative',
    marginRight: 16,
    marginBottom: 16,
    width: 150,
    height: 150
  },
  imageIcon: {
    backgroundColor: 'white',
    position: 'absolute',
    top: '8px',
    left: '8px',
    padding: '4px',
    borderRadius: '4px',
    lineHeight: 0
  },
});
export default userProfileStyles;
